import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { POPUP_BUYERS } from "../lib/constants";
export function BuyerPopup() {
  const [visible, setVisible] = useState(false);
  const [index, setIndex] = useState(0);
  const [minutes, setMinutes] = useState(3);
  useEffect(() => {
    let showTimer: ReturnType<typeof setTimeout>;
    let hideTimer: ReturnType<typeof setTimeout>;
    const cycle = () => {
      setIndex(prev => (prev + 1) % POPUP_BUYERS.length);
      setMinutes(Math.floor(Math.random() * 8) + 1);
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), 5000);
    };

    // first show
    showTimer = setTimeout(cycle, 3500);
    const interval = setInterval(cycle, 11000);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, []);
  const buyer = POPUP_BUYERS[index];
  return <AnimatePresence data-id="element-119" data-mp="31t09kz4cquyv">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 30,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.35
    }} className="fixed bottom-4 left-3 right-3 z-50 mx-auto max-w-sm rounded-2xl border border-slate-200 bg-white p-3 shadow-2xl sm:left-4 sm:right-auto" data-id="element-120" data-mp="31tt7rbp8wc5e">
          <div className="flex items-start gap-3" data-id="element-121" data-mp="3kj8813x3wx8q">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#e7f0ea]" data-id="element-122" data-mp="3km43mllhf9u0">
              <CheckCircle2Icon className="h-6 w-6 text-[#1f4d3a]" data-id="element-123" data-mp="3fnaokoqjrarq" />
            </div>
            <div className="min-w-0 flex-1 pr-4" data-id="element-124" data-mp="3ug4hpcyqrpev">
              <p className="text-[13px] font-semibold text-slate-800" data-id="element-125" data-mp="3pium1fkrehil">
                {buyer.name} de {buyer.city}
              </p>
              <p className="text-[12px] text-slate-500" data-id="element-126" data-mp="204po2l2m15tu">
                acaba de comprar el{" "}
                <span className="font-semibold text-[#1f4d3a]" data-id="element-127" data-mp="1v6o0bmu8oic1">Kit RRHH</span>
              </p>
              <p className="mt-0.5 text-[11px] text-slate-400" data-id="element-128" data-mp="2kuteafwqbqnp">
                hace {minutes} min · compra verificada ✅
              </p>
            </div>
            <button type="button" aria-label="Cerrar" onClick={() => setVisible(false)} className="absolute right-2 top-2 text-slate-400 hover:text-slate-600" data-id="element-129" data-mp="2ttdqcy7sb22y">
              <XIcon className="h-4 w-4" data-id="element-130" data-mp="33rbbhcuckirc" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}